























































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Handbook, HandbookCategoryDetails, HandbookSubCategory } from "@/api";
import Loading from "@/components/loader/loading.vue";
import HandbookCategoryForm from "@/views/admin/handbook/HandbookCategoryForm.vue";
import ConfirmationModule from "@/components/confirmationModule/ConfirmationModule.vue";
import HandbookForm from "@/views/admin/handbook/HandbookForm.vue";
import HandbookEditForm from "@/views/admin/handbook/HandbookEditForm.vue";

@Component({
  components: {
    Loading,
    HandbookCategoryForm,
    ConfirmationModule,
    HandbookForm,
    HandbookEditForm,
  },
  watch: {
    async $route() {
      this.$data.oading = true;
      await this.$store.dispatch(
        "handbook/fetchCategoryDetails",
        this.$route.params.categoryId,
      );
      this.$data.loading = false;
    },
  },
})
export default class HandbookCategoryDetail extends Vue {
  loading = false;
  archiving = false;
  dialog = false;
  subDialog = false;
  editSubDialog = false;
  handbookDialog = false;
  editHandbookDialog = false;
  confirmDialog = false;
  confirmSubDialog = false;
  confirmHandbookDialog = false;
  count = 0;
  selectEditSubcategory: HandbookSubCategory | null = null;
  selectEditHandbook: Handbook | null = null;
  newSubCategory = {} as HandbookSubCategory;
  newHandbook = {} as Handbook;
  selectEditSubvategoryname = "";

  async created() {
    this.loading = true;
    await this.$store.dispatch(
      "handbook/fetchCategoryDetails",
      this.$route.params.categoryId,
    );
    this.loading = false;
  }

  back() {
    this.$router.back();
  }

  get categoryDetails(): HandbookCategoryDetails {
    const res = this.$store.getters[
      "handbook/categoryDetails"
    ] as HandbookCategoryDetails;

    const categoryId = res ? res.handbookCategory?.id || 0 : 0;
    if (categoryId) {
      this.newSubCategory.categoryId = categoryId;
      this.newHandbook.categoryId = categoryId;
    }

    return res;
  }

  getHandbookName(handbook: Handbook) {
    if (handbook.subCategoryId) {
      const subCat = this.categoryDetails.subcategories.find(
        sub => sub.id === handbook.subCategoryId,
      );

      if (subCat) {
        return `${subCat.name} - ${handbook.name}`;
      } else return "";
    }
    return handbook.name;
  }

  async archiveCategory() {
    this.archiving = true;
    await this.$store.dispatch(
      "handbook/deleteHandbookCategory",
      this.categoryDetails.handbookCategory,
    );
    this.archiving = false;
    this.confirmDialog = !this.confirmDialog;
    this.$router.push("/admin/company-handbook");
  }

  editSubCategory(subCategory: HandbookSubCategory) {
    this.count++;
    this.selectEditSubcategory = subCategory;
    this.selectEditSubvategoryname = this.selectEditSubcategory.name;
    this.editSubDialog = !this.editSubDialog;
  }

  async archiveSubCategory() {
    this.archiving = true;
    await this.$store.dispatch(
      "handbook/deleteHandbookSubCategory",
      this.selectEditSubcategory,
    );
    this.archiving = false;
    this.confirmSubDialog = !this.confirmSubDialog;
  }

  async archiveHandbook() {
    this.archiving = true;
    this.archiving = true;
    await this.$store.dispatch(
      "handbook/deleteHandbook",
      this.selectEditHandbook,
    );
    this.archiving = false;
    this.confirmHandbookDialog = !this.confirmHandbookDialog;
  }
}
